import * as React from "react"

const SvgCube = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 19.854v-6.85L5 9.529v6.85zm2 0 6-3.475v-6.85l-6 3.475zm-1-8.575 5.925-3.425L12 4.429 6.075 7.854zm-8 6.85a1.95 1.95 0 0 1-1-1.725v-7.95a1.95 1.95 0 0 1 1-1.725l7-4.025a1.96 1.96 0 0 1 2 0l7 4.025a1.95 1.95 0 0 1 1 1.725v7.95a1.95 1.95 0 0 1-1 1.725l-7 4.025q-.475.275-1 .275c-.525 0-.683-.092-1-.275z" />
  </svg>
)
export default SvgCube
